module.exports = __webpack_public_path__ + "static/media/overall-risk-thumbnail.edd70b12.png";